import React, {useEffect} from 'react';
import css from './App.module.css';
import Header from "./Header/Header";
import MapContainer from "./MapContainer";
import {bootstrap} from "../../store/coreSlice";
import {connect} from 'react-redux';
import Layers from "./Live/Layers/Layers";
import Settings from "./Settings/Settings";
import {useParams} from "react-router";
import {setPage, Page} from "../../store/coreSlice";
import Nests from "./Nests";
import {setFilters, fetchPreset} from "../../store/filterSlice";
import S2Cells from "./S2/S2Cells";
import News from "./News";
import LinkDiscord from "../Helper/Discord/LinkDiscord";
import {isDevel} from "../../utils";
import Defenders from "./Defenders/Defenders";

function App(props) {
	let {filterId} = useParams();

	useEffect(() => {
		// console.log("Calling bootstrap...");
		props.bootstrap(filterId); // eslint-disable-next-line
	}, []);

	useEffect(() => {
		if( props.defaultPage === Page.NESTS ) {
			// console.log("Set page: Nests");
			props.setPage(Page.NESTS);
		} else if( props.defaultPage === Page.S2 ) {
			// console.log("Set page: S2");
			props.setPage(Page.S2);

			// Kinda hacky
			const s2Filters = {"showPokemon":false,"showRaids":false,"showStops":true,"showGyms":true,showSpawnpoints:false,"goldBadge":0,"gymTeam":0,"gymStagnationDays":0,"gymOpenSpotsOnly":false,"gymExFilter":false,"raidLevel1":true,"raidLevel2":true,"raidLevel3":true,"raidLevel4":true,"raidLevel5":true,"raidLevel6":true,"raidExFilter":false,"stopOverlay":3,"stopLureOnlySpecial":false,"stopQuestLevel":1,"stopGruntLevel":0,"stopShowAll":true,"pokemonQuality":20,"pokemonSpecies":[]};
			props.setFilters(s2Filters);
		} else {
			// console.log("Set page: Live");
			if( !filterId ) {
				const lastFilters = localStorage.getItem('lastFilters');
				if (lastFilters) {
					// console.log("Reconstituting saved filters", JSON.parse(lastFilters));
					props.setFilters(JSON.parse(lastFilters));
				}
			}
			props.setPage(Page.LIVE);
		} // eslint-disable-next-line
	}, [props.defaultPage]);

	useEffect(() => {
		if( !props.bootstrapped || !filterId )
			return;

		const currentPreset = props.presets.find(preset => preset.filter_id === +filterId);
		console.log("filterId changed: ", filterId, currentPreset);
		if( currentPreset ) {
			if( currentPreset.filters )
				props.setFilters(currentPreset.filters);
		} else {
			props.fetchPreset(filterId);
		}// eslint-disable-next-line
	}, [filterId, props.bootstrapped]);

	if( !props.bootstrapped )
		return <p>Loading...</p>;

	if( !props.discordUser && !isDevel() )
		return <LinkDiscord title='Link Discord Account' onClose={() => {document.location.href = '/';}}/>;

	return (
		<div className={css.App}>
			{ props.news && <News /> }
			<Header className={css.Header}/>
			{ props.showFilters && <Layers /> }
			<Settings />
			<Defenders />
			{/*{props.isAdmin && <Debug />}*/}
			<Nests/>
			{props.pendingSubmissions && <S2Cells/>}
			<div className={css.MapContainer}>
				<MapContainer/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
        bootstrapped: state.core.bootstrapped,
        showFilters: state.core.showFilters,
		page: state.core.page,
		presets: state.core.presets,
		news: state.core.news,
		pendingSubmissions: state.core.pendingSubmissions,
		discordUser: state.core.discordUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        bootstrap: (filterId) => dispatch(bootstrap(filterId)),
		setPage: (page) => dispatch(setPage(page)),
		setFilters: (filters) => dispatch(setFilters(filters)),
		fetchPreset: (filters) => dispatch(fetchPreset(filters)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(App);
